import lockersIcon from '../assets/images/parking/lockers-white.svg';
import shedIcon from '../assets/images/parking/shed-white.svg';
import standsIcon from '../assets/images/parking/stands-white.svg';
import wallLoopIcon from '../assets/images/parking/wall-loop-white.svg';
import bicycleRepairIcon from '../assets/images/poi/bicycle-repair-white.svg';
import chargingStationIcon from '../assets/images/poi/charging-station-white.svg';
import picnicIcon from '../assets/images/poi/picnic-white.svg';
import pumpIcon from '../assets/images/poi/pump-white.svg';
import toiletsIcon from '../assets/images/poi/toilets-white.svg';
import waterPointIcon from '../assets/images/poi/water-point-white.svg';
import accidentIcon from '../assets/images/report/accident-white.svg';
import badWeatherIcon from '../assets/images/report/bad-weather-white.svg';
import barrierIcon from '../assets/images/report/barrier-white.svg';
import bicycleDammageIcon from '../assets/images/report/bicycle-dammage-white.svg';
import bicycleFacilityRequestIcon from '../assets/images/report/bicycle-facility-request-white.svg';
import bicycleParkingRequestIcon from '../assets/images/report/bicycle-parking-request-white.svg';
import brokenGlassIcon from '../assets/images/report/broken-glass-white.svg';
import collisionWithBicycleIcon from '../assets/images/report/collision-with-bicycle-white.svg';
import collisionWithCarDoorIcon from '../assets/images/report/collision-with-car-door-white.svg';
import collisionWithPedestrianIcon from '../assets/images/report/collision-with-pedestrian-white.svg';
import collisionWithVehiculeIcon from '../assets/images/report/collision-with-vehicule-white.svg';
import dangerousCrossingIcon from '../assets/images/report/dangerous-crossing-white.svg';
import dangerousRoadIcon from '../assets/images/report/dangerous-road-white.svg';
import deadLeavesIcon from '../assets/images/report/dead-leaves-white.svg';
import eventOnRoadIcon from '../assets/images/report/event-on-road-white.svg';
import fallIcon from '../assets/images/report/fall-white.svg';
import floodIcon from '../assets/images/report/flood-white.svg';
import freezingRainIcon from '../assets/images/report/freezing-rain-white.svg';
import gcumIcon from '../assets/images/report/gcum-white.svg';
import heavyCarTrafficIcon from '../assets/images/report/heavy-car-traffic-white.svg';
import heavyPedestrianTrafficIcon from '../assets/images/report/heavy-pedestrian-traffic-white.svg';
import incivilitiesIcon from '../assets/images/report/incivilities-white.svg';
import kerbIcon from '../assets/images/report/kerb-white.svg';
import mapErrorIcon from '../assets/images/report/map-error-white.svg';
import missingFacilityIcon from '../assets/images/report/missing-facility-white.svg';
import missingParkingIcon from '../assets/images/report/missing-parking-white.svg';
import missingPoiIcon from '../assets/images/report/missing-poi-white.svg';
import missingTrafficSignIcon from '../assets/images/report/missing-traffic-sign-white.svg';
import needMaintenanceIcon from '../assets/images/report/need-maintenance-white.svg';
import noLightingIcon from '../assets/images/report/no-lighting-white.svg';
import noMarkingIcon from '../assets/images/report/no-marking-white.svg';
import obstaclesIcon from '../assets/images/report/obstacles-white.svg';
import pebblesIcon from '../assets/images/report/pebbles-white.svg';
import poleIcon from '../assets/images/report/pole-white.svg';
import policePresenceIcon from '../assets/images/report/police-presence-white.svg';
import potholeIcon from '../assets/images/report/pothole-white.svg';
import roadworksIcon from '../assets/images/report/roadworks-white.svg';
import rootsIcon from '../assets/images/report/roots-white.svg';
import snowIcon from '../assets/images/report/snow-white.svg';
import supportLocalAuthoritiesIcon from '../assets/images/report/support-local-authorities-white.svg';
import trafficIcon from '../assets/images/report/traffic-white.svg';
import vegetationIcon from '../assets/images/report/vegetation-white.svg';
import { AccidentIcon, BadWeatherIcon, BarrierIcon, BicycleDammageIcon, BicycleFacilityRequestIcon, BicycleParkingRequestIcon, BicycleRepairIcon, BlockedRoadIcon, BollardIcon, BrokenGlassIcon, CartographicIssueIcon, ChargingStationIcon, CollisionWithBicycleIcon, CollisionWithCarDoorIcon, CollisionWithPedestrianIcon, CollisionWithVehiculeIcon, DangerIcon, DangerousCrossingIcon, DangerousRoadIcon, DeadLeavesIcon, EventOnRoadIcon, FallIcon, FloodIcon, FreezingRainIcon, GCUMIcon, HeavyCarTrafficIcon, HeavyPedestrianTrafficIcon, KerbIcon, LockersIcon, MapErrorIcon, MissingFacilityIcon, MissingParkingIcon, MissingPoiIcon, MissingTrafficSignIcon, NeedFacilityIcon, NeedMaintenanceIcon, NoLightingIcon, NoMarkingIcon, ObstaclesIcon, PebblesIcon, PicnicIcon, PoleIcon, PolicePresenceIcon, PotholeIcon, PumpIcon, RoadworksIcon, RootsIcon, ShedIcon, SnowIcon, StandsIcon, SupportLocalAuthoritiesIcon, TheftIcon, ToiletsIcon, TrafficConditionsIcon, TrafficIcon, VegetationIcon, WallLoopIcon, WaterPointIcon } from '../components/icons';
export const reportTypesCategories = ['trafficConditions', 'roadBlocked', 'danger', 'mapError', 'needFacility', 'supportLocalAuthorities'];
const trafficConditionsParentsCodes = ['heavyCarTraffic', 'heavyPedestrianTraffic', 'policePresence', 'heavyBicycleTraffic'];
const roadBlockedParentsCodes = ['badWeather', 'roadwork', 'roadBlockedObstacle', 'eventOnRoad', 'roadBlockedOther'];
const dangerParentsCodes = ['accident', 'dangerous', 'obstacles', 'needMaintenance', 'incivilities', 'dangerOther'];
const mapErrorParentsCodes = ['bikeFacility', 'bikeParkings', 'unlistedBicycleService', 'cartographicIssue'];
const needFacilityParentsCodes = ['bicycleFacilityRequest', 'bicycleParkingRequest', 'missingTrafficSign', 'noMarking', 'noLighting'];
export const reportParentsCodes = [...trafficConditionsParentsCodes, ...roadBlockedParentsCodes, ...dangerParentsCodes, ...mapErrorParentsCodes, ...needFacilityParentsCodes, 'supportLocalAuthorities'];
export const reportTypesCategoriesMap = {
  trafficConditions: {
    Icon: TrafficConditionsIcon,
    titleKey: 'commons.report_types.traffic_conditions',
    children: trafficConditionsParentsCodes
  },
  roadBlocked: {
    Icon: BlockedRoadIcon,
    titleKey: 'commons.report_types.road_blocked',
    children: roadBlockedParentsCodes
  },
  danger: {
    Icon: DangerIcon,
    titleKey: 'commons.report_types.danger',
    children: dangerParentsCodes
  },
  mapError: {
    Icon: MapErrorIcon,
    titleKey: 'commons.report_types.map_error',
    children: mapErrorParentsCodes
  },
  needFacility: {
    Icon: NeedFacilityIcon,
    titleKey: 'commons.report_types.need_facility',
    children: needFacilityParentsCodes
  },
  supportLocalAuthorities: {
    Icon: SupportLocalAuthoritiesIcon,
    titleKey: 'commons.report_types.support_local_authorities',
    children: ['supportLocalAuthorities']
  }
};
const reportTypeBadWeatherCodes = ['snow', 'flood'];
const reportTypeAccidentCodes = ['collisionWithVehicule', 'collisionWithCarDoor', 'collisionWithBicycle', 'fall', 'collisionWithPedestrian', 'accidentOther'];
const reportTypeDangerousCodes = ['kerb', 'brokenGlass', 'freezingRain', 'deadLeaves', 'pebbles', 'dangerousCrossing', 'dangerousOther'];
const reportTypeObstaclesCodes = ['barrier', 'vegetation', 'gcum', 'pole', 'obstaclesOther'];
const reportTypeNeedMaintenanceCodes = ['pothole', 'roots', 'degradedRoadSurface'];
const reportTypeIncivilitiesCodes = ['theft', 'bicycleDammage'];
const reportTypeBikeParkingsCodes = ['bikeParkingStands', 'bikeParkingLockers', 'bikeParkingBollard', 'bikeParkingWallLoop', 'bikeParkingShed'];
const reportTypeUnlistedBicycleServiceCodes = ['unlistedBicyclePump', 'unlistedBicycleRepair', 'unlistedChargingStation', 'unlistedToilets', 'unlistedPicnicArea', 'unlistedWaterPoint'];
export const reportTypeOthers = ['exclusionZone', 'support', 'toDoToSee'];
export const _reportTypeOthers = ['exclusionZone', 'support', 'toDoToSee'];
export const reportTypesChildren = {
  // trafficConditions
  heavyCarTraffic: {
    children: [],
    isBindToOSM: false
  },
  heavyPedestrianTraffic: {
    children: [],
    isBindToOSM: false
  },
  policePresence: {
    children: [],
    isBindToOSM: false
  },
  heavyBicycleTraffic: {
    children: [],
    isBindToOSM: false
  },
  // roadBlocked
  badWeather: {
    children: reportTypeBadWeatherCodes,
    isBindToOSM: false
  },
  roadwork: {
    children: [],
    isBindToOSM: false
  },
  roadBlockedObstacle: {
    children: [],
    isBindToOSM: false
  },
  eventOnRoad: {
    children: [],
    isBindToOSM: false
  },
  roadBlockedOther: {
    children: [],
    isBindToOSM: false
  },
  // danger
  accident: {
    children: reportTypeAccidentCodes,
    isBindToOSM: false
  },
  dangerous: {
    children: reportTypeDangerousCodes,
    isBindToOSM: false
  },
  obstacles: {
    children: reportTypeObstaclesCodes,
    isBindToOSM: false
  },
  needMaintenance: {
    children: reportTypeNeedMaintenanceCodes,
    isBindToOSM: false
  },
  incivilities: {
    children: reportTypeIncivilitiesCodes,
    isBindToOSM: false
  },
  dangerOther: {
    children: [],
    isBindToOSM: false
  },
  // mapError
  bikeFacility: {
    children: [],
    isBindToOSM: true
  },
  bikeParkings: {
    children: reportTypeBikeParkingsCodes,
    isBindToOSM: true
  },
  unlistedBicycleService: {
    children: reportTypeUnlistedBicycleServiceCodes,
    isBindToOSM: true
  },
  cartographicIssue: {
    children: [],
    isBindToOSM: true
  },
  // needFacility
  bicycleFacilityRequest: {
    children: [],
    isBindToOSM: false
  },
  bicycleParkingRequest: {
    children: [],
    isBindToOSM: false
  },
  missingTrafficSign: {
    children: [],
    isBindToOSM: false
  },
  noMarking: {
    children: [],
    isBindToOSM: false
  },
  noLighting: {
    children: [],
    isBindToOSM: false
  },
  // supportLocalAuthorities
  supportLocalAuthorities: {
    children: [],
    isBindToOSM: false
  }
};
export class ReportType {
  constructor(id, code, isBindToOSM, titleKey, children) {
    this.id = id;
    this.code = code;
    this.isBindToOSM = isBindToOSM;
    this.titleKey = titleKey;
    this.children = children;
  }
}
export const reportTypesTitleKeys = {
  // trafficConditions
  heavyCarTraffic: 'commons.report_types.heavy_car_traffic',
  heavyPedestrianTraffic: 'commons.report_types.heavy_pedestrian_traffic',
  policePresence: 'commons.report_types.police_presence',
  heavyBicycleTraffic: 'commons.report_types.heavy_bicycle_traffic',
  // roadBlocked
  badWeather: 'commons.report_types.bad_weather',
  snow: 'commons.report_types.snow',
  flood: 'commons.report_types.flood',
  roadwork: 'commons.report_types.roadwork',
  roadBlockedObstacle: 'commons.report_types.obstacles',
  eventOnRoad: 'commons.report_types.event_on_road',
  roadBlockedOther: 'commons.report_types.other',
  // danger
  accident: 'commons.report_types.accident',
  collisionWithVehicule: 'commons.report_types.collision_with_vehicule',
  collisionWithCarDoor: 'commons.report_types.collision_with_car_door',
  collisionWithBicycle: 'commons.report_types.collision_with_bicycle',
  fall: 'commons.report_types.fall',
  collisionWithPedestrian: 'commons.report_types.collision_with_pedestrian',
  accidentOther: 'commons.report_types.other',
  dangerous: 'commons.report_types.dangerous',
  kerb: 'commons.report_types.kerb',
  brokenGlass: 'commons.report_types.broken_glass',
  freezingRain: 'commons.report_types.freezing_rain',
  deadLeaves: 'commons.report_types.dead_leaves',
  pebbles: 'commons.report_types.pebbles',
  dangerousCrossing: 'commons.report_types.dangerous_crossing',
  dangerousOther: 'commons.report_types.other',
  obstacles: 'commons.report_types.obstacles',
  barrier: 'commons.report_types.barrier',
  vegetation: 'commons.report_types.vegetation',
  gcum: 'commons.report_types.gcum',
  pole: 'commons.report_types.pole',
  obstaclesOther: 'commons.report_types.other',
  needMaintenance: 'commons.report_types.need_maintenance',
  pothole: 'commons.report_types.pothole',
  roots: 'commons.report_types.roots',
  degradedRoadSurface: 'commons.report_types.other',
  incivilities: 'commons.report_types.incivilities',
  theft: 'commons.report_types.theft',
  bicycleDammage: 'commons.report_types.bicycle_dammage',
  dangerOther: 'commons.report_types.other',
  // mapError
  bikeFacility: 'commons.report_types.bike_facility',
  bikeParkings: 'commons.report_types.bike_parkings',
  bikeParkingStands: 'commons.report_types.bike_parking_stands',
  bikeParkingLockers: 'commons.report_types.bike_parking_lockers',
  bikeParkingBollard: 'commons.report_types.bike_parking_bollard',
  bikeParkingWallLoop: 'commons.report_types.bike_parking_wall_loop',
  bikeParkingShed: 'commons.report_types.bike_parking_shed',
  unlistedBicycleService: 'commons.report_types.unlisted_bicycle_service',
  unlistedBicyclePump: 'commons.report_types.unlisted_bicycle_pump',
  unlistedBicycleRepair: 'commons.report_types.unlisted_bicycle_repair',
  unlistedChargingStation: 'commons.report_types.unlisted_charging_station',
  unlistedToilets: 'commons.report_types.unlisted_toilets',
  unlistedPicnicArea: 'commons.report_types.unlisted_picnic_area',
  unlistedWaterPoint: 'commons.report_types.unlisted_water_point',
  cartographicIssue: 'commons.report_types.cartographic_issue',
  // needFacility
  bicycleFacilityRequest: 'commons.report_types.bicycle_facility_request',
  bicycleParkingRequest: 'commons.report_types.bicycle_parking_request',
  missingTrafficSign: 'commons.report_types.missing_traffic_sign',
  noMarking: 'commons.report_types.no_marking',
  noLighting: 'commons.report_types.no_lighting',
  // supportLocalAuthorities
  supportLocalAuthorities: 'commons.report_types.support_local_authorities',
  // others
  exclusionZone: 'commons.report_types.exclusion_zone',
  support: 'commons.report_types.support',
  toDoToSee: 'commons.report_types.to_do_to_see'
};
export const reportTypesMap = {
  // trafficConditions
  policePresence: {
    Icon: PolicePresenceIcon,
    color: '#37b1e5',
    icon: policePresenceIcon
  },
  heavyBicycleTraffic: {
    Icon: TrafficIcon,
    color: '#37b1e5',
    icon: trafficIcon
  },
  heavyCarTraffic: {
    Icon: HeavyCarTrafficIcon,
    color: '#37b1e5',
    icon: heavyCarTrafficIcon
  },
  heavyPedestrianTraffic: {
    Icon: HeavyPedestrianTrafficIcon,
    color: '#37b1e5',
    icon: heavyPedestrianTrafficIcon
  },
  // roadBlocked
  badWeather: {
    Icon: BadWeatherIcon,
    color: '#da3a87',
    icon: badWeatherIcon
  },
  snow: {
    Icon: SnowIcon,
    color: '#B9BDC3',
    icon: snowIcon,
    obstacleDetailsRequired: true
  },
  flood: {
    Icon: FloodIcon,
    color: '#528BE8',
    icon: floodIcon,
    obstacleDetailsRequired: true
  },
  roadwork: {
    Icon: RoadworksIcon,
    color: '#da3a87',
    icon: roadworksIcon,
    obstacleDetailsRequired: true,
    endDateEnabled: true
  },
  roadBlockedObstacle: {
    Icon: ObstaclesIcon,
    color: '#da3a87',
    icon: obstaclesIcon,
    obstacleDetailsRequired: true,
    endDateEnabled: true
  },
  eventOnRoad: {
    Icon: EventOnRoadIcon,
    color: '#da3a87',
    icon: eventOnRoadIcon,
    obstacleDetailsRequired: true,
    endDateEnabled: true
  },
  roadBlockedOther: {
    Icon: ObstaclesIcon,
    color: '#da3a87',
    icon: obstaclesIcon,
    isOther: true,
    obstacleDetailsRequired: true,
    endDateEnabled: true
  },
  // danger
  accident: {
    Icon: AccidentIcon,
    color: '#fa823e',
    icon: accidentIcon
  },
  collisionWithVehicule: {
    Icon: CollisionWithVehiculeIcon,
    color: '#fa823e',
    icon: collisionWithVehiculeIcon,
    descriptionAllowed: true,
    startDateEnabled: true
  },
  collisionWithCarDoor: {
    Icon: CollisionWithCarDoorIcon,
    color: '#fa823e',
    icon: collisionWithCarDoorIcon,
    descriptionAllowed: true,
    startDateEnabled: true
  },
  collisionWithBicycle: {
    Icon: CollisionWithBicycleIcon,
    color: '#fa823e',
    icon: collisionWithBicycleIcon,
    descriptionAllowed: true,
    startDateEnabled: true
  },
  fall: {
    Icon: FallIcon,
    color: '#fa823e',
    icon: fallIcon,
    descriptionAllowed: true,
    startDateEnabled: true
  },
  collisionWithPedestrian: {
    Icon: CollisionWithPedestrianIcon,
    color: '#fa823e',
    icon: collisionWithPedestrianIcon,
    descriptionAllowed: true,
    startDateEnabled: true
  },
  accidentOther: {
    Icon: AccidentIcon,
    color: '#fa823e',
    icon: accidentIcon,
    isOther: true,
    descriptionRequired: true,
    startDateEnabled: true
  },
  dangerous: {
    Icon: DangerousRoadIcon,
    color: '#fa823e',
    icon: dangerousRoadIcon
  },
  kerb: {
    Icon: KerbIcon,
    color: '#2c2e30',
    icon: kerbIcon
  },
  brokenGlass: {
    Icon: BrokenGlassIcon,
    color: '#2c2e30',
    icon: brokenGlassIcon
  },
  freezingRain: {
    Icon: FreezingRainIcon,
    color: '#2c2e30',
    icon: freezingRainIcon
  },
  deadLeaves: {
    Icon: DeadLeavesIcon,
    color: '#2c2e30',
    icon: deadLeavesIcon
  },
  pebbles: {
    Icon: PebblesIcon,
    color: '#2c2e30',
    icon: pebblesIcon
  },
  dangerousCrossing: {
    Icon: DangerousCrossingIcon,
    color: '#2c2e30',
    icon: dangerousCrossingIcon,
    descriptionRequired: true
  },
  dangerousOther: {
    Icon: DangerousRoadIcon,
    color: '#2c2e30',
    icon: dangerousRoadIcon,
    isOther: true,
    descriptionRequired: true
  },
  obstacles: {
    Icon: ObstaclesIcon,
    color: '#fa823e',
    icon: obstaclesIcon
  },
  barrier: {
    Icon: BarrierIcon,
    color: '#fa823e',
    icon: barrierIcon,
    obstacleDetailsRequired: true
  },
  vegetation: {
    Icon: VegetationIcon,
    color: '#fa823e',
    icon: vegetationIcon,
    obstacleDetailsRequired: true
  },
  gcum: {
    Icon: GCUMIcon,
    color: '#fa823e',
    icon: gcumIcon,
    obstacleDetailsRequired: true
  },
  pole: {
    Icon: PoleIcon,
    color: '#fa823e',
    icon: poleIcon,
    obstacleDetailsRequired: true
  },
  obstaclesOther: {
    Icon: ObstaclesIcon,
    color: '#fa823e',
    icon: obstaclesIcon,
    isOther: true,
    obstacleDetailsRequired: true
  },
  needMaintenance: {
    Icon: NeedMaintenanceIcon,
    color: '#fa823e',
    icon: needMaintenanceIcon
  },
  pothole: {
    Icon: PotholeIcon,
    color: '#fa823e',
    icon: potholeIcon,
    photoAllowed: true
  },
  roots: {
    Icon: RootsIcon,
    color: '#fa823e',
    icon: rootsIcon,
    photoAllowed: true
  },
  degradedRoadSurface: {
    Icon: NeedMaintenanceIcon,
    color: '#fa823e',
    icon: needMaintenanceIcon,
    photoAllowed: true,
    isOther: true
  },
  incivilities: {
    Icon: TheftIcon,
    color: '#fa823e',
    icon: incivilitiesIcon
  },
  theft: {
    Icon: TheftIcon,
    color: '#fa823e',
    icon: incivilitiesIcon,
    startDateEnabled: true
  },
  bicycleDammage: {
    Icon: BicycleDammageIcon,
    color: '#fa823e',
    icon: bicycleDammageIcon,
    startDateEnabled: true
  },
  dangerOther: {
    Icon: DangerousRoadIcon,
    color: '#fa823e',
    icon: barrierIcon,
    isOther: true,
    descriptionRequired: true
  },
  // mapError
  bikeFacility: {
    Icon: MissingFacilityIcon,
    color: '#048760',
    icon: missingFacilityIcon,
    photoRequired: true,
    descriptionRequired: true
  },
  bikeParkings: {
    Icon: MissingParkingIcon,
    color: '#048760',
    icon: missingParkingIcon
  },
  bikeParkingStands: {
    Icon: StandsIcon,
    color: '#326AC2',
    icon: standsIcon,
    photoRequired: true,
    descriptionRequired: true,
    parkingCapacityEnabled: true
  },
  bikeParkingWallLoop: {
    Icon: WallLoopIcon,
    color: '#326AC2',
    icon: wallLoopIcon,
    photoRequired: true,
    descriptionRequired: true,
    parkingCapacityEnabled: true
  },
  bikeParkingShed: {
    Icon: ShedIcon,
    color: '#326AC2',
    icon: shedIcon,
    photoRequired: true,
    descriptionRequired: true,
    parkingCapacityEnabled: true
  },
  bikeParkingBollard: {
    Icon: BollardIcon,
    color: '#326AC2',
    icon: standsIcon,
    photoRequired: true,
    descriptionRequired: true,
    parkingCapacityEnabled: true
  },
  bikeParkingLockers: {
    Icon: LockersIcon,
    color: '#326AC2',
    icon: lockersIcon,
    photoRequired: true,
    descriptionRequired: true,
    parkingCapacityEnabled: true
  },
  unlistedBicycleService: {
    Icon: MissingPoiIcon,
    color: '#048760',
    icon: missingPoiIcon
  },
  unlistedBicycleRepair: {
    Icon: BicycleRepairIcon,
    color: '#5ABA52',
    icon: bicycleRepairIcon,
    descriptionRequired: true,
    descriptionLabelKey: 'commons.name'
  },
  unlistedChargingStation: {
    Icon: ChargingStationIcon,
    color: '#EBAF25',
    icon: chargingStationIcon
  },
  unlistedWaterPoint: {
    Icon: WaterPointIcon,
    color: '#37B1E5',
    icon: waterPointIcon
  },
  unlistedToilets: {
    Icon: ToiletsIcon,
    color: '#969696',
    icon: toiletsIcon
  },
  unlistedPicnicArea: {
    Icon: PicnicIcon,
    color: '#5ABA52',
    icon: picnicIcon
  },
  unlistedBicyclePump: {
    Icon: PumpIcon,
    color: '#F260A7',
    icon: pumpIcon
  },
  cartographicIssue: {
    Icon: CartographicIssueIcon,
    color: '#048760',
    icon: mapErrorIcon,
    photoRequired: true,
    descriptionRequired: true
  },
  // needFacility
  bicycleFacilityRequest: {
    Icon: BicycleFacilityRequestIcon,
    color: '#bb8a1a',
    icon: bicycleFacilityRequestIcon
  },
  bicycleParkingRequest: {
    Icon: BicycleParkingRequestIcon,
    color: '#bb8a1a',
    icon: bicycleParkingRequestIcon
  },
  missingTrafficSign: {
    Icon: MissingTrafficSignIcon,
    color: '#bb8a1a',
    icon: missingTrafficSignIcon,
    descriptionRequired: true
  },
  noMarking: {
    Icon: NoMarkingIcon,
    color: '#bb8a1a',
    icon: noMarkingIcon
  },
  noLighting: {
    Icon: NoLightingIcon,
    color: '#bb8a1a',
    icon: noLightingIcon
  },
  // supportLocalAuthorities
  supportLocalAuthorities: {
    Icon: SupportLocalAuthoritiesIcon,
    color: '#FFFFFF00',
    icon: supportLocalAuthoritiesIcon
  }
};